import { atom } from 'jotai';

import { ChatItemContent } from '@/lib/types/content';

export const loadedChatContentAtom = atom<ChatItemContent[]>([]);
export const currentChatIdAtom = atom<string>('');
export const currentQuestionAtom = atom<string>('');
export const questionTextareaValueAtom = atom<string>('');
export const isLoadingAtom = atom<boolean>(false);
export const isStreamingAtom = atom<boolean>(false);
export const abortControllerAtom = atom<AbortController | null>(new AbortController());
